// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-check.hilite-tag:hover {
	background-color:  rgba(255, 0, 0, .4);
}

.hilite-for-over {
	animation: hilite .7s linear infinite ;
	border: 2px solid #FF0000 !important;
}

#aiTagSuggestionModal .badge {
	border: 2px solid transparent;
}

#aiTagSuggestionModal .form-check {
	border-radius: .4em;
	padding-left: 1.75em;
}

@keyframes hilite {
	0% { opacity: 1; scale: 1; }
	50% { opacity: .4; scale: 1.1; }
	100% { opacity: 1; scale: 1; }
}`, "",{"version":3,"sources":["webpack://./src/components/aiTagSuggestion/style.css"],"names":[],"mappings":"AAAA;CACC,sCAAsC;AACvC;;AAEA;CACC,sCAAsC;CACtC,oCAAoC;AACrC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;CACC,KAAK,UAAU,EAAE,QAAQ,EAAE;CAC3B,MAAM,WAAW,EAAE,UAAU,EAAE;CAC/B,OAAO,UAAU,EAAE,QAAQ,EAAE;AAC9B","sourcesContent":[".form-check.hilite-tag:hover {\r\n\tbackground-color:  rgba(255, 0, 0, .4);\r\n}\r\n\r\n.hilite-for-over {\r\n\tanimation: hilite .7s linear infinite ;\r\n\tborder: 2px solid #FF0000 !important;\r\n}\r\n\r\n#aiTagSuggestionModal .badge {\r\n\tborder: 2px solid transparent;\r\n}\r\n\r\n#aiTagSuggestionModal .form-check {\r\n\tborder-radius: .4em;\r\n\tpadding-left: 1.75em;\r\n}\r\n\r\n@keyframes hilite {\r\n\t0% { opacity: 1; scale: 1; }\r\n\t50% { opacity: .4; scale: 1.1; }\r\n\t100% { opacity: 1; scale: 1; }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
